import React from 'react';
import {connect, DispatchProp} from "react-redux";
import {DateHelper} from "../../services/Common/Date/DateHelper";
import {getAvailabilities, getMenus} from "../../services/Menu/reducer";
import AvailableHelper from "../../services/Menu/services/Availability/AvailableHelper";
import {useTranslation, withTranslation} from "react-i18next";
import {RootState} from "../../../reducers";
import {getLocation} from "../../services/Session/reducer";
import {getStoreConfig} from "../../services/Store/reducer";
import {useSessionService} from "../../services/Session/sessionService";
import PickUpDateDrawer from "../Drawer/PickUpDateDrawer/PickUpDateDrawer";
import {OrderType} from "../../services/Api/types";
import {getParsedSessionOrderType} from "../../utils/order";

interface OwnProps {
    pickDate: any;
    showDrawer: boolean;
    onHide: () => void;
    higherZIndex?: boolean;
    handleSaveDate?: (date: string) => void;
    withoutAsSoonAsPossibleOption?: true;
    orderType?: OrderType;
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps & DispatchProp;

function ChangePickDateDrawer(props: Props) {
    const {t} = useTranslation();
    const sessionService = useSessionService();
    const parsedOrderType = getParsedSessionOrderType(props.orderType);

    const savePickDate = async (date: any) => {
        const dateValue = date ? DateHelper.format(date) : "";
        if (props.handleSaveDate) {
            props.handleSaveDate(dateValue)
        } else {
            await sessionService.update({
                ...props.session_state,
                pickup_at: dateValue
            });
        }
        props.onHide();
    }

    const menus = parsedOrderType
        ? props.menus.filter((menu: any) => parsedOrderType && menu[parsedOrderType?.toLowerCase()] === true && menu.availability_id)
        : props.menus;
    const dates = AvailableHelper.getAllDates(menus, props.availabilities);
    const menuAvailabilities = AvailableHelper.getAvailabilities(props.availabilities, menus.map((menu: any) => menu.availability_id));
    const weekDays = AvailableHelper.getAllWeekDays(menus, props.availabilities);

    return <PickUpDateDrawer config={props.config}
                             orderType={props.orderType ?? props.session_state.order_type}
                             dates={dates}
                             weekDays={weekDays} availabilities={menuAvailabilities}
                             onSave={savePickDate}
                             withoutAsSoonAsPossibleOption={props.withoutAsSoonAsPossibleOption}
                             title={t("modules.date_modal.field.order_pick_up_date.title")}
                             value={props.pickDate}
                             show={props.showDrawer} onHide={props.onHide}
                             higherZIndex={props.higherZIndex}/>
}

const mapStateToProps = (state: RootState) => ({
    availabilities: getAvailabilities(state.menu),
    menus: getMenus(state.menu),
    session_state: getLocation(state.session),
    config: getStoreConfig(state.config)
})

const connector = connect(mapStateToProps);
export default withTranslation()(connector(ChangePickDateDrawer));